import { APP } from '../../redux/constants/app.constants';

export const USER_PAGE = `${APP}/USER_PAGE`;

export const DELETE_USERS = `${USER_PAGE}/DELETE_USERS`;
export const RESET_USER = `${USER_PAGE}/RESET_USER`;
export const RESET_2FA = `${USER_PAGE}/RESET_2FA`;
export const TOGGLE_2FA = `${USER_PAGE}/TOGGLE_2FA`;